import {conf} from '../AppConf'
import * as _ from 'lodash';

export interface ReportData {
    dates: string[];
    crimson: number[];
    yale: number[];
    tehranTimes: number[];
    financialTribune: number[];
}

export interface Series {
    x: number[];
    y: number[]
}

export interface SentimentResponseTO {
    all: Series,
    withKeyword: Series
}

export interface SiteFilterData {
    name: string,
    url: string
}

export interface TweetBankFilterData {
    id: number,
    phraseEn: string,
    phraseFa: string
}

export const emptySeries = {x: [], y: []}

export const emptyTweetSentimentData = {
    all: emptySeries,
    withKeyword: emptySeries,
}


export const getReportData = (keyword: string): Promise<ReportData> =>
    api<ReportData>(`/report/keyword/${keyword}`);

export const getArticlesSentimentData = (keyword: string, startMonth: number, startYear: number, endYear: number, siteNames: string[]): Promise<Map<string, SentimentResponseTO>> => {
    if (keyword.length === 0 || siteNames.length === 0 || startYear > endYear) {
        return Promise.resolve(new Map<string, SentimentResponseTO>());
    }
    let names = _.join(siteNames, ',')
    return api<Object>(`/report/sentiment/articles/${keyword}?startMonth=${startMonth}&startYear=${startYear}&endYear=${endYear}&siteNames=${names}`)
        .then(obj => {
            return new Map<string, SentimentResponseTO>(Object.entries(obj));
        })

}

export const getTweetsSentimentData = (tweedBankId: number, keyword: string, startMonth: number, startYear: number, endYear: number, groupBy: string): Promise<Series> => {
    if (keyword.length === 0 || startYear > endYear) {
        return Promise.resolve(emptySeries);
    }
    return api<Series>(`/report/sentiment/tweets/average/keyword/${tweedBankId}/${keyword}?startMonth=${startMonth}&startYear=${startYear}&endYear=${endYear}&groupBy=${groupBy}`)
}


export const getAverageTweetsSentimentData = (tweedBankId: number, startMonth: number, startYear: number, endYear: number, groupBy: string): Promise<Series> => {
    if (startYear > endYear) {
        return Promise.resolve(emptySeries);
    }
    return api<Series>(`/report/sentiment/tweets/average/${tweedBankId}?startMonth=${startMonth}&startYear=${startYear}&endYear=${endYear}&groupBy=${groupBy}`)
}

export const getSiteFilterData = (): Promise<SiteFilterData[]> =>
    api<SiteFilterData[]>(`/report/filter/site`)

export const getTweetBankFilterData = (): Promise<TweetBankFilterData[]> =>
    api<TweetBankFilterData[]>(`/report/filter/tweet-bank`)

function api<T>(url: string, opt?: RequestInit): Promise<T> {
    return fetch(conf.rest.baseUrl + url, opt)
        .then(response => {
            if (!response.ok) {
                throw new Error(response.statusText)
            }
            return response.json() as Promise<T>
        })
}